import { Avatar, Box, Button, lighten, PaletteColor, Typography, useTheme } from '@mui/material';
import React from 'react';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { IconName } from '@fortawesome/fontawesome-svg-core';

export type PreviewOverlayHeaderProps = {
    title: string;
    icon?: IconName;
    color?: PaletteColor;
    onClose: () => void;
};

const PreviewOverlayHeader: React.FunctionComponent<PreviewOverlayHeaderProps> = function (props) {
    const { title, icon, color: colorProp, onClose: handleClose } = props;
    const { palette } = useTheme();
    const color = colorProp || palette.primary;

    const headerSx = {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        padding: '30px',
    };

    const nameSx = { color: color.dark };

    const closeWrapperSx = {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        padding: 0,
        marginLeft: 'auto',
        width: '30px',
        height: '30px',
        minWidth: 'auto',
        minHeight: 'auto',
    };

    const closeSx = {
        color: palette.grey[500],
        fontSize: '24px',
        lineHeight: '24px',
    };

    const avatarSx = {
        display: 'flex',
        borderRadius: '8px',
        backgroundColor: lighten(color.main, 0.92),
        minHeight: '36px',
        minWidth: '36px',
    };

    const avatarIconSx = {
        fontSize: '16px',
        lineHeight: '16px',
        fontWeight: '400',
        color: color.main,
    };

    return (
        <Box sx={headerSx}>
            <Box>
                {icon && (
                    <Avatar
                        data-testid="document-icon"
                        sx={avatarSx}
                    >
                        <FaOptionIcon
                            icon={['fasl', icon]}
                            sx={avatarIconSx}
                        />
                    </Avatar>
                )}
            </Box>
            <Box>
                <Typography
                    component="span"
                    sx={nameSx}
                    variant="l2dh7"
                >
                    {title}
                </Typography>
            </Box>
            <Button
                onClick={handleClose}
                sx={closeWrapperSx}
                data-testid="close-button"
            >
                <FaOptionIcon
                    sx={closeSx}
                    icon={['fasl', 'close']}
                />
            </Button>
        </Box>
    );
};

export default PreviewOverlayHeader;
